import { connect } from 'react-redux';

// Types
import { ButtonType } from '../../types/button-type';

// Store
import { RootState } from '../../store/store';

// Components
import InteractiveButton from '../InteractiveButton/InteractiveButton';
import IconLeaf from '../Icons/IconLeaf/IconLeaf';

type MfaQrCodeProps = ReturnType<typeof mapState> & {
  onClick: (text: string) => void;
};

const MfaQrCode = (props: MfaQrCodeProps) => {
  const { onClick, mfaSetupData } = props;

  const clickToCopyQrCode = () => {
    onClick(mfaSetupData?.code || '');
  }

  return (
    <div className='c-mfa-set-up-data flex flex-col justify-center gap-y-2'>
      <div className='c-mfa-set-up-data__wrapper-qr-code relative'>
        <IconLeaf iconClassName='absolute z-1 -left-[24%] bottom-[16%]' />
        <div className='p-3 bg-[#E3752E] relative z-9 rounded-lg'>
          <img className='c-mfa-set-up-data__qr-code w-50 h-50 block bg-white p-4 rounded-lg' src={mfaSetupData?.qrImage || ''} />
        </div>
        <IconLeaf iconClassName='absolute z-1 transform rotate-[102deg] bottom-[30%] left-[86%]' />
      </div>
      <InteractiveButton className='' type={ButtonType.Transparent} onClick={clickToCopyQrCode} text='Copy key' />
    </div>
  )
};

const mapState = (state: RootState) => ({
  mfaSetupData: state.auth.mfaSetupData,
});

export default connect(mapState, null)(MfaQrCode);

